import { render, staticRenderFns } from "./ChartsSdkSlot.vue?vue&type=template&id=1860f3b0&scoped=true"
import script from "./ChartsSdkSlot.vue?vue&type=script&lang=js"
export * from "./ChartsSdkSlot.vue?vue&type=script&lang=js"
import style0 from "./ChartsSdkSlot.vue?vue&type=style&index=0&id=1860f3b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1860f3b0",
  null
  
)

export default component.exports